import { __awaiter, __generator } from 'tslib';
import { getScriptRuns, getScripts, KpkApiScriptType } from '@keepeek/api-client';
import Axios from 'axios';
import { selector } from 'recoil';
import { scriptsRequestIdState } from './atoms.js';

var scriptsSelector = selector({
    key: "ScriptsSelector",
    get: function (_a) {
        var get = _a.get;
        return __awaiter(void 0, void 0, void 0, function () {
            var scriptsResult, scriptRunsResult, data;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        get(scriptsRequestIdState);
                        return [4 /*yield*/, getScripts(Axios, {
                                page: 1,
                                size: 50,
                                type: [KpkApiScriptType.Standalone, KpkApiScriptType.Flexible]
                            })];
                    case 1:
                        scriptsResult = _c.sent();
                        return [4 /*yield*/, getScriptRuns(Axios, {
                                page: 1,
                                size: 300
                            })];
                    case 2:
                        scriptRunsResult = _c.sent();
                        data = ((_b = scriptsResult.data._embedded) === null || _b === void 0 ? void 0 : _b.script.map(function (script) {
                            var _a;
                            // this code is a port of the old script-manager project and I am aware
                            // that this part is not perfect because if we cannot find the script in the list of executed scripts,
                            // we do not go back from the last execution of the script ... it's not dramatic but we could
                            // improve the behavior by changing the Keepeek API to pass the script id as a parameter
                            // in order to retrieve the last execution ...
                            var scriptRunMatch = (_a = scriptRunsResult.data._embedded) === null || _a === void 0 ? void 0 : _a.scriptRun.find(function (run) { var _a; return (_a = run._links) === null || _a === void 0 ? void 0 : _a["kpk:script"].href.endsWith("/api/dam/scripts/".concat(script.id)); });
                            var lastRun = scriptRunMatch && {
                                id: scriptRunMatch.id || 0,
                                startDate: scriptRunMatch.startDate || "",
                                scriptTitle: scriptRunMatch.scriptTitle || "",
                                endDate: scriptRunMatch.endDate
                            };
                            return {
                                id: script.id || 0,
                                title: script.title || "",
                                lastRun: lastRun
                            };
                        })) || [];
                        return [2 /*return*/, {
                                data: data,
                                totalCount: scriptsResult.data.totalCount || 0
                            }];
                }
            });
        });
    }
});

export { scriptsSelector };
//# sourceMappingURL=selectors.js.map
